<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <overview-death-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <death-overview />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import OverviewDeathSideNav from "./components/OverviewDeathSideNav.vue"
import DeathOverview from "./components/DeathOverview.vue"

export default {
    name: 'AnimalDeath_overview_page',
    components: {
        OverviewDeathSideNav,
        DeathOverview
    },
    data() {
        return {
            Id: '',
            animal: [],
            gets: []
        }
    },
    async mounted() {        
    },
}
</script>